module.exports = __webpack_public_path__ + "static/media/LogoDiaDasMães_Branca.65d01177.png";